export const SET_ONBOARDING_STEP = 'SET_ONBOARDING_STEP',
  ABORT_ONBOARDING = 'ABORT_ONBOARDING',
  ACTIVE_ONBOARDING = 'ACTIVE_ONBOARDING'

const initialState = {
  isActive: false,
  index: 0,
}

export default function (
  state = {
    ...initialState,
  },
  action = {}
) {
  switch (action.type) {
    case ACTIVE_ONBOARDING:
      return {
        ...state,
        index: action.step,
        isActive: true,
      }
    case SET_ONBOARDING_STEP:
      return {
        ...state,
        index: action.step,
      }
    case ABORT_ONBOARDING:
      return {
        ...state,
        isActive: false,
      }
    default:
      return state
  }
}
